var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddPerson = function SvgAddPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    transform: "rotate(90 38.5 0)",
    fill: "#12AA60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.982 22.954a5.347 5.347 0 0 1 3.781-1.566h7.486a5.347 5.347 0 0 1 5.348 5.347v2.14a1.07 1.07 0 1 1-2.14 0v-2.14a3.208 3.208 0 0 0-3.208-3.208h-7.486a3.208 3.208 0 0 0-3.208 3.208v2.14a1.07 1.07 0 1 1-2.139 0v-2.14c0-1.418.563-2.778 1.566-3.78ZM15.506 10.694a3.208 3.208 0 1 0 0 6.416 3.208 3.208 0 0 0 0-6.416Zm-5.347 3.208a5.347 5.347 0 1 1 10.695 0 5.347 5.347 0 0 1-10.695 0ZM27.805 13.902c.59 0 1.07.479 1.07 1.07v6.416a1.07 1.07 0 0 1-2.14 0v-6.417c0-.59.48-1.069 1.07-1.069Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.527 18.18c0-.59.48-1.07 1.07-1.07h6.416a1.07 1.07 0 0 1 0 2.14h-6.416a1.07 1.07 0 0 1-1.07-1.07Z",
    fill: "#fff"
  })));
};
export default SvgAddPerson;